import React, { useContext } from "react";
import LazyLoad from "react-lazy-load";
import formatCurrency from "../../func/currency_formatter";
import { TemplateContext } from "../../layout";
import TagIcon from "../../utils/images/tagIcon";
import DiscountTagBlock from "../DiscountTagBlock.jsx";

const ProductCardNew = ({ product, modifications, index, type }) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const discountCodeEnabled = templateContext.discountsEnabled;
  const isDiscountApplied = templateContext.discountCode === window.productData?.discount_codes?.discount_code;
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const warrantyAmount = window.productData?.multiply_price_by_amount ? templateContext.config?.product.amount : 1;
  const warrantyPrice = templateContext?.config?.warrantyState
    ? templateContext.config?.product.warranty_price * warrantyAmount
    : 0.0;
  const fallbackImages = window.post_template.checkout_v4_products.checkout_v4_product_images;
  const bundleFallbackImgForSummary = window?.post_template.checkout_v4_products?.fallback_bundle_summary_img;
  const matchingImage =
    fallbackImages && fallbackImages.find((obj) => obj.product_amount === product.amount)?.product_image;
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;
  const oldPrice = templateContext.config.warrantyState
    ? Number(product.old_price) + Number(warrantyPrice)
    : Number(product.old_price).toFixed(2);

  const getPrice = (product, isDiscountApplied, discountsEnabled, warrantyPrice = 0) => {
    let basePrice;
    if (discountsEnabled && isDiscountApplied && product?.promo_discounted_price) {
      basePrice = Number(product.promo_discounted_price);
    } else {
      basePrice = Number(product.price);
    }

    return basePrice * product.amount + Number(warrantyPrice);
  };

  let price = getPrice(product, isDiscountApplied, discountCodeEnabled, warrantyPrice);

  const productPriceBlock = () => {
    let formattedPrice;
    let formattedOldPrice;
    if (templateContext?.priceWithCents) {
      formattedPrice = product.formatted_price
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number(price).toFixed(2))
        : formatCurrency(product.price);

      formattedOldPrice = window.formattedString
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number(oldPrice).toFixed(2))
        : formatCurrency(oldPrice);
    } else {
      formattedPrice = product.formatted_price
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number(price))
        : formatCurrency(product.price);

      formattedOldPrice = window.formattedString
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number(oldPrice))
        : formatCurrency(oldPrice);
    }
    return (
      <div className="productCard__priceBlock">
        <span className="productCard__priceBlock__oldPrice">{formattedOldPrice}</span>
        <span className="productCard__priceBlock__price">{formattedPrice}</span>
      </div>
    );
  };

  const fakeProductPrice = window.formattedString
    ? window.formattedString.replace(/(0\.00|0,00|0)/, product.price)
    : formatCurrency(product.price);
  const fakeProductPriceBlock = () => {
    return (
      <div className="productCard__priceBlock">
        <span className="productCard__priceBlock__oldPrice">{fakeProductPrice}</span>
        <span className="productCard__priceBlock__price">{product.price_line_label}</span>
      </div>
    );
  };

  return (
    <div key={index} className={`productCard ${modifications?.DrawerProducts ? "productCard_smallMargin" : ""}`}>
      <div className="productCard__imageContainer">
        <LazyLoad height={64} width={64}>
          <img
            src={bundleFallbackImgForSummary ? bundleFallbackImgForSummary : product.image.url}
            alt={general_settings.brand_name}
            className="mon-img-64-w mon-img-64-h"
          />
        </LazyLoad>
        <span data-cy="summary-product-amount" className="productCard__imageContainer__indicator">
          {product.amount}
        </span>
      </div>
      <div className="productCard__titleBlock">
        <div data-cy="summary-product-title" className="productCard__titleBlock__title">
          {product.display_name}{" "}
          {type !== "fake" && templateContext.config.warrantyState && <span>{warrantyLabel}</span>}
        </div>
        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
        {product.tr_additional_texts && (
          <div className="productCard__titleBlock__altText">{product.tr_additional_texts}</div>
        )}
        {type == "fake" ? (
          <>
            {product.tag_label && (
              <div className="productCard__titleBlock__tagText">
                <TagIcon />
                {product.tag_label} {`(-${fakeProductPrice})`}
              </div>
            )}
          </>
        ) : (
          <>
            {templateContext?.discountCode && (
              <div className="productCard__titleBlock__tagText">
                <TagIcon />
                {templateContext.discountCode} {`(-${formatCurrency(oldPrice - price.toFixed(2))})`}
              </div>
            )}
          </>
        )}
      </div>
      {type !== "fake" ? productPriceBlock() : fakeProductPriceBlock()}
    </div>
  );
};
export default ProductCardNew;
